
namespace RioERP.Wallet {

    @Serenity.Decorators.registerClass()
    export class CreditWalletGrid extends Serenity.EntityGrid<CreditWalletRow, any> {
        protected getColumnsKey() { return CreditWalletColumns.columnsKey; }
        protected getDialogType() { return CreditWalletDialog; }
        protected getIdProperty() { return CreditWalletRow.idProperty; }
        protected getInsertPermission() { return CreditWalletRow.insertPermission; }
        protected getLocalTextPrefix() { return CreditWalletRow.localTextPrefix; }
        protected getService() { return CreditWalletService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getQuickFilters() {
            var filter = super.getQuickFilters();
            if (Authorization.hasPermission("Users:Franchisee") && !Authorization.hasPermission("Administration:Security")) {
                filter.splice(0, 2);
            }

            return filter;
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(1, 3);

           
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: CreditWalletService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            
            return buttons;
        }
    }
}